// React
import React from "react";
import PropTypes from "prop-types";
// Helpers
import { isNil } from "@mefisto/utils";
// Framework
import { classnames } from "ui/classnames";
import { makeStyles } from "@material-ui/core";

////////////////////////////////////////////////////
/// Styles
////////////////////////////////////////////////////

const useStyles = makeStyles({
  responsive: ({ aspectRatio }) => ({
    width: "100%",
    ...(aspectRatio && { aspectRatio }),
  }),
});

////////////////////////////////////////////////////
/// Component
////////////////////////////////////////////////////

const StaticImage = ({
  image,
  width,
  height,
  aspectRatio,
  display = "block",
  description = "",
  style,
  draggable = false,
  className,
}) => {
  // Styles
  const classes = useStyles({ aspectRatio });
  // Render
  return (
    <img
      src={image}
      alt={description}
      className={classnames(
        className,
        !(width || height) && classes.responsive
      )}
      style={{
        display,
        maxWidth: isNil(width) ? "none" : width,
        maxHeight: isNil(height) ? "none" : height,
        ...style,
      }}
      width={width}
      height={height}
      draggable={draggable}
    />
  );
};

StaticImage.propTypes = {
  image: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  aspectRatio: PropTypes.number,
  display: PropTypes.string,
  description: PropTypes.string,
  style: PropTypes.object,
  draggable: PropTypes.bool,
  className: PropTypes.string,
};

export default StaticImage;
